import { Modal } from "tailwindcss-stimulus-components"

export default class extends Modal {
  static targets = ["form", "errors"]

  connect() {
    super.connect()
  }

  handleSuccess({ detail: { success } }) {
    if (success) {
      // super.close()
      this.clearErrors()
      // this.formTarget.reset()
    } else {
      this.element.querySelectorAll("[type=submit]").forEach(e => {
        e.disabled = false
      })
    }
  }

  clearErrors() {
    if (this.hasErrorsTarget) {
      this.errorsTarget.remove()
    }
  }
}
